try {
    window.$ = window.jQuery = require('jquery');

    require('jquery-ui');
    require('jquery-ui/ui/effects/effect-shake');
    require('jquery-ui/ui/widgets/button');
    require('jquery-ui/ui/widgets/autocomplete');
    require('jquery-ui/ui/widgets/draggable');
    require('jquery-ui/ui/widgets/sortable');

    require('bootstrap');
} catch (e) {
    console.error(e);
}

require('admin-lte');
require('chosen-js');
require('bootstrap-datepicker');
